import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-parent" }
const _hoisted_2 = { class: "grey-form-card position-relative" }
const _hoisted_3 = { class: "card-parent" }
const _hoisted_4 = { class: "small-grey preset-header" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" + Add new preset ")
const _hoisted_6 = { class: "list-parent" }
const _hoisted_7 = { class: "table-parent" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "el-icon-more" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Edit site preset")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Delete site preset")
const _hoisted_11 = { class: "paging-place" }
const _hoisted_12 = { class: "paging-label" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Showing ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" from ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" data ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_TableHeaderComponent = _resolveComponent("TableHeaderComponent")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_PresetForm = _resolveComponent("PresetForm")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h6", _hoisted_4, " Site Presets (" + _toDisplayString(_ctx.state.paging.total) + ") ", 1),
        _createVNode(_component_el_button, {
          class: "single-button add-preset-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editPreset()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _withDirectives(_createVNode(_component_el_table, {
              class: "list-table",
              ref: "multipleTable",
              data: _ctx.list.data,
              style: {"width":"100%"},
              "header-row-class-name": "header-row",
              stripe: true,
              "empty-text": "Nothing is found. Please change your search parameters"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "Name",
                  "min-width": "150",
                  fixed: ""
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_TableHeaderComponent, {
                      header: 'Name',
                      sortable: true,
                      sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.name),
                      onChangeSorting: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.name, $event)))
                    }, null, 8, ["sortingValue"])
                  ]),
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "MMSE Score",
                  width: "170"
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_TableHeaderComponent, { header: 'MMSE Score' })
                  ]),
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatRangePhone(
                      scope.row.score_mmse_from,
                      scope.row.score_mmse_to
                    )), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Operator",
                  "min-width": "240"
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_TableHeaderComponent, { header: 'Operator' })
                  ]),
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString((scope.row.operator_type || "")
                      .replace("AndOr", "And/Or")
                      .toUpperCase()), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "ADAScog",
                  "min-width": "240"
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_TableHeaderComponent, { header: 'ADAScog' })
                  ]),
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatRangePhone(
                      scope.row.score_adascog_from,
                      scope.row.score_adascog_to
                    )), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Age",
                  "min-width": "240"
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_TableHeaderComponent, { header: 'Age' })
                  ]),
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatRangePhone(scope.row.age_from, scope.row.age_to)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Sex",
                  "min-width": "240"
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_TableHeaderComponent, { header: 'Sex' })
                  ]),
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatSex(scope.row.sex_types)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  "class-name": "actions-cell",
                  label: "Actions",
                  fixed: "right",
                  width: "83"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_dropdown, {
                      type: "primary",
                      trigger: "click"
                    }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (_ctx.editPreset(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (_ctx.deletePreset(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, null, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]), [
              [_directive_loading, _ctx.state.isLoading]
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("span", null, _toDisplayString(_ctx.list.data.length), 1),
                _hoisted_14,
                _createVNode("span", null, _toDisplayString(_ctx.state.paging.total), 1),
                _hoisted_15
              ]),
              (_ctx.state.paging.total > _ctx.state.paging.pageSize)
                ? (_openBlock(), _createBlock(_component_el_pagination, {
                    key: 0,
                    class: "table-paging",
                    layout: "prev, pager, next",
                    "current-page": _ctx.state.paging.page,
                    "page-size": _ctx.state.paging.pageSize,
                    "pager-count": 5,
                    total: _ctx.state.paging.total,
                    onCurrentChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pageChange($event)))
                  }, null, 8, ["current-page", "page-size", "total"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.popupTitle,
      modelValue: _ctx.state.dialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.dialogVisible = $event)),
      width: "80%",
      top: "5vh"
    }, {
      default: _withCtx(() => [
        (_ctx.state.dialogVisible)
          ? (_openBlock(), _createBlock(_component_PresetForm, {
              key: 0,
              siteId: _ctx.siteId,
              editModel: _ctx.state.currentPreset,
              onUpdated: _ctx.modelUpdated,
              onCancel: _ctx.cancel
            }, null, 8, ["siteId", "editModel", "onUpdated", "onCancel"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}